CustomBackgroundOptionsView = require 'app/scripts/views/board-menu/custom-background-options-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
{ Analytics } = require '@trello/atlassian-analytics'
templates = require 'app/scripts/views/internal/templates'
_ = require 'underscore'
View = require 'app/scripts/views/internal/view'
{ track } = require '@trello/analytics'


module.exports = class SelectCustomBackgroundView extends View
  initialize: ->
    @listenTo @model, 'change:id', @render
    @listenTo @model, 'change:error', @render

  className: 'board-background-select js-select-background'

  events:
    'click .js-options': 'openOptions'
    'click': 'selectBackground'

  render: ->
    data = @model.toJSON()
    data.pending = !@getId()? && !data.error?

    if !data.color?
      data.backgroundImageThumbnail =
        Util.previewBetween(@model.get('scaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl')

    @$el.html(
      templates.fill(
        require('app/scripts/views/templates/board_background_selection'),
        data
      )
    )

    @$el.toggleClass('is-still-uploading-background', data.pending)

    @

  openOptions: (e) ->
    Util.stop(e)
    Analytics.sendClickedLinkEvent
      linkName: 'backgroundOptionsLink'
      source: 'boardMenuDrawerBackgroundScreen'
    PopOver.toggle
      elem: @$('.js-options')
      view: new CustomBackgroundOptionsView({ @model, @modelCache })

  getId: ->
    @model.id

  selectBackground: (e) ->
    Util.stop(e)
    return if !@getId()?

    board = @options.board
    # Update the local data so we don't have to wait for the server to respond
    _.extend(board.attributes.prefs, {
      backgroundColor: @model.get('color')
      backgroundImage: @model.get('fullSizeUrl')
      backgroundImageScaled: @model.get('scaled')
      backgroundTile: @model.get('tile') ? false
      backgroundBrightness: @model.get('brightness') ? 'unknown'
    })

    board.setPref "background", @getId()

    track("Board Menu", "Change Background", @getId())
    Analytics.sendUpdatedBoardFieldEvent
      field: 'background',
      value: @getId()
      source: 'boardMenuDrawerBackgroundScreen',
      containers:
        board:
          id: board.id
        organization:
          id: board.getOrganization()?.id
      attributes:
        backgroundType: 'custom'

    return
